import { spawn } from 'redux-saga/effects';
import { sagas as throttleDispatchSagas } from './throttleDispatch';
import copyToClipboardSagas from './copyToClipboard/sagas';

export default function* utilitySagas() {
	yield spawn(throttleDispatchSagas);
	yield spawn(copyToClipboardSagas);
}
